<script setup lang="ts">
import { Facebook, Twitter, Instagram, Link2 } from 'lucide-vue-next'

const emit = defineEmits(['share'])

const handleShare = (platform: string) => {
  emit('share', platform)
}
</script>

<template>
  <section class="bg-white rounded-2xl shadow-sm p-6">
    <h3 class="text-lg font-semibold text-gray-900 mb-4">Share Profile</h3>
    <div class="flex items-center gap-3">
      <button
        class="flex-1 bg-blue-500 text-white p-3 rounded-xl hover:bg-blue-600 transition-colors"
        @click="handleShare('facebook')"
      >
        <Facebook class="w-5 h-5 mx-auto" fill="currentColor" />
      </button>
      <button
        class="flex-1 bg-sky-500 text-white p-3 rounded-xl hover:bg-sky-600 transition-colors"
        @click="handleShare('twitter')"
      >
        <Twitter class="w-5 h-5 mx-auto" fill="currentColor" />
      </button>
      <button
        class="flex-1 bg-pink-500 text-white p-3 rounded-xl hover:bg-pink-600 transition-colors"
        @click="handleShare('instagram')"
      >
        <Instagram class="w-5 h-5 mx-auto" />
      </button>
      <button
        class="flex-1 bg-gray-700 text-white p-3 rounded-xl hover:bg-gray-800 transition-colors"
        @click="handleShare('copy-link')"
      >
        <Link2 class="w-5 h-5 mx-auto" />
      </button>
    </div>
  </section>
</template>
